<script lang="ts">
  export let label = '';
  export let placeholder = '';
  export let value: string;
  export let id = '';
  export let required = false;

  let inputElement: HTMLInputElement;

  export function reportValidity() {
    return inputElement.reportValidity();
  }
</script>

<style lang="postcss">
  .container {
    display: grid;
    gap: 0.25rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .container {
      grid-template-columns: 1fr 2fr 1fr;
      align-items: start;
      gap: 1.5rem;
    }

    .container > div:first-child {
      display: flex;
      align-items: center;
      justify-content: end;
      min-height: var(--ubilabs-input-height);
    }
  }

  .input {
    width: 100%;
  }
</style>

<div class="container {$$props.class}">
  <div>
    {#if label}
      <label for={id}>{label}{required ? '*' : ''}</label>
    {/if}
  </div>
  <div>
    <input
      class="input"
      type="text"
      name={id}
      {id}
      {required}
      {placeholder}
      bind:value
      bind:this={inputElement} />
  </div>
</div>
